import React, { useEffect } from 'react';
import { Box, Grid, makeStyles, Paper, Typography } from '@material-ui/core';
import { ErrorBoundary } from 'react-error-boundary';
import { ToggleButtonGroup, ToggleButton } from '@material-ui/lab';

import TermSelectionFilters from './TermSelectionFilters';
// import {
//   ACTIONS,
//   SessionSchedulerContextProvider,
//   useSessionSchedulerContext,
// } from './useSessionSchedulerContext';
import {
  ACTIONS,
  SessionSchedulerContextProvider,
  useSessionSchedulerContext,
} from '../../../../Context/sessionSchedulerContextForExam';
import { getFacultyAndFacilty } from '../../../../Utils/apiServices';
import Calendar from './Calendar';
import { EVENT_TYPE_OPTIONS, RESOURCE_TYPES_OPTIONS } from './schedulerHelper';
import KenCard from '../../../../global_components/KenCard';
import SubjectSectionSelector from './SubjectSectionSelector';

export const useToggleStyles = makeStyles((theme) => ({
  root: {
    '&&': {
      display: 'inline-flex',
      // color: theme.palette.KenColors.primary,
      backgroundColor: theme.palette.KenColors.kenWhite,
      boxShadow:
        '0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%)',
      '&:hover': {
        boxShadow: 'none',
      },
    },
  },
  selected: {
    '&&': {
      // backgroundColor: theme.palette.KenColors.primary,
      backgroundColor: '#2C3E50',
      color: theme.palette.KenColors.kenWhite,
      '&:hover': {
        // backgroundColor: theme.palette.KenColors.primary,
        backgroundColor: '#1a252f',
        color: theme.palette.KenColors.kenWhite,
        boxShadow: 'none',
      },
    },
  },
}));

function Scheduler() {
  console.log('SessionScheduler 1');

  const {
    state: { term, resourceType, eventType, courseVersionData },
    dispatch,
    fetchDataByTerm,
  } = useSessionSchedulerContext();

  const toggleClasses = useToggleStyles();

  useEffect(() => {
    fetchDataByTerm(term, {});
  }, [term]);

  const handleSubjectChange = (v) => {
    console.log('handleSubjectChange: ', v);
    // Dispatch selected subjects an alter events for this
    dispatch({
      type: ACTIONS.UPDATE_SELECTED_SUBJECTS,
      value: v,
    });
  };

  useEffect(() => {
    // get all faculty, facility and activity
    getFacultyAndFacilty()
      .then((res) => {
        if (res) {
          dispatch({
            type: ACTIONS.UPDATE_FACULTY_FACILITY_ACTIVITIES,
            value: res,
          });
        }
      })
      .catch((err) => {
        console.log('SessionScheduler: getFacultyAndFacilty: ', err);
      });
  }, []);

  return (
    <div>
      <Paper elevation={0}>
        <Box p={2} mt={1}>
          <Typography variant="h6" color="primary" mb={2}>
            <b>Exam Planning</b>
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <TermSelectionFilters
                onAcademicData={(v) => {
                  dispatch({ type: ACTIONS.UPDATE_ACADEMIC_DATA, value: v });
                }}
                onProgramChange={(v) => {
                  dispatch({ type: ACTIONS.UPDATE_PROGRAM, value: v });
                }}
                onYearChange={(v) => {
                  dispatch({ type: ACTIONS.UPDATE_YEAR, value: v });
                }}
                onIntakeChange={(v) => {
                  dispatch({ type: ACTIONS.UPDATE_INTAKE, value: v });
                }}
                onTermChange={(v) => {
                  dispatch({ type: ACTIONS.UPDATE_TERM, value: v });
                }}
              />
            </Grid>
            <Grid item xs={6} sm={3} md={2} style={{ marginTop: 'auto' }}>
              <ToggleButtonGroup
                size="small"
                value={resourceType}
                exclusive
                onChange={(e, newValue) => {
                  dispatch({
                    type: ACTIONS.UPDATE_RESOURCE_TYPE,
                    value: newValue,
                  });
                }}
              >
                {RESOURCE_TYPES_OPTIONS.map((r) => (
                  <ToggleButton
                    classes={toggleClasses}
                    value={r.value}
                    aria-label={r.label}
                  >
                    {r.label}
                  </ToggleButton>
                ))}
              </ToggleButtonGroup>
            </Grid>
            <Grid item xs={6} sm={3} md={3} style={{ marginTop: 'auto' }}>
              <ToggleButtonGroup
                size="small"
                color="primary"
                exclusive
                value={eventType}
                onChange={(e, newValue) => {
                  dispatch({
                    type: ACTIONS.UPDATE_EVENT_TYPE,
                    value: newValue,
                  });
                }}
              >
                {EVENT_TYPE_OPTIONS.map((r) => (
                  <ToggleButton
                    classes={toggleClasses}
                    value={r.value}
                    aria-label={r.label}
                    onClick={() => {}}
                  >
                    {r.label}
                  </ToggleButton>
                ))}
              </ToggleButtonGroup>
            </Grid>
          </Grid>
        </Box>
      </Paper>
      <KenCard>
        <Grid container spacing={2}>
          <Grid item xs={12} md={3}>
            <SubjectSectionSelector
              onSelectedChange={handleSubjectChange}
              data={courseVersionData}
            />
          </Grid>
          <Grid item xs={12} md={9}>
            <Calendar fetchDataByTerm={fetchDataByTerm} />
          </Grid>
        </Grid>
      </KenCard>
    </div>
  );
}

export default function ExamPlanner() {
  return (
    <div>
      <ErrorBoundary
        fallbackRender={({ error, resetErrorBoundary, componentStack }) => (
          <div>
            <h1>An error occurred: {error.message}</h1>
            <button onClick={resetErrorBoundary}>Try again</button>
          </div>
        )}
      >
        <SessionSchedulerContextProvider>
          <Scheduler />
        </SessionSchedulerContextProvider>
      </ErrorBoundary>
    </div>
  );
}
